import { Button, Chip, makeStyles, Modal, Tooltip } from '@material-ui/core';
import { AddCircle, Language, MoreHoriz, Smartphone, Tablet } from '@material-ui/icons';
import React, { useReducer, useState } from 'react';
import {
  DEVICE_NAMES,
  hotelServiceModules,
  guestRoomExpModules,
  HOTEL_SYSTEMS_TITLES,
  entertainmentModules,
} from '../../../../constants/ConfigurationsConst';
import { confirmHotelSystemsModuleConfigurations } from '../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import './../HotelSystems.scss';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ModuleSummary = (props) => {
  const { hotelId, onConfirm, isConfirmed, onModuleSectionClick, onConfigClick } = props;
  const [selectedValue, setSelectedValue] = useState(null);
  const [summaryList, setSummaryList] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    props.moduleSummaryList,
  );
  const moduleList = {
    hotelServiceModules: hotelServiceModules,
    guestRoomExpModules: guestRoomExpModules,
    entertainmentModules: entertainmentModules,
  };
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleDeviceClick = (section, device, index) => {
    const tempModuleValue = summaryList[section][index].module;
    const tempModuleName = moduleList[section].find((item) => item.key === tempModuleValue).value;
    if (!isConfirmed) {
      setSelectedValue({
        section: section,
        device: device,
        index: index,
        doEnable: !summaryList[section][index].enabledDevices[device],
        moduleName: tempModuleName,
      });
    }
  };

  const onStatusBtnClick = () => {
    const { section, index, device } = selectedValue;
    const currSection = { ...summaryList }[section];
    currSection[index].enabledDevices[device] = !currSection[index].enabledDevices[device];
    setSummaryList({ [section]: currSection });
    setSelectedValue(null);
  };

  const handleClose = () => {
    setSelectedValue(null);
  };

  const handleConfirm = async () => {
    const res = await confirmHotelSystemsModuleConfigurations(hotelId, summaryList);
    if (res.data.updateHotelSystemModulesConfigurations.status) {
      notificationManager('success', 'All selected modules have been activated');
      onConfirm(summaryList);
    }
  };

  const handleConfigure = (section) => {
    onConfigClick(section);
  };

  return (
    <div>
      <div className='d-flex mt-4 justify-content-between'>
        <div className='sub-title'>Module summary</div>
        {isConfirmed && (
          <div className='d-flex'>
            {Object.keys(HOTEL_SYSTEMS_TITLES).map((section, i) => (
              <label
                key={i}
                onClick={() => onModuleSectionClick(section)}
                className='gray-text cursor-pointer bold-text px-3'
              >
                {HOTEL_SYSTEMS_TITLES[section]}
              </label>
            ))}
          </div>
        )}
      </div>
      <div className='row d-flex mt-4'>
        <div className='card p-4 shadow module-summary'>
          {Object.keys(HOTEL_SYSTEMS_TITLES).map((section, i) => (
            <div key={i}>
              <div className='d-flex justify-content-between align-items-center module-summary-section-title p-3'>
                <div>{HOTEL_SYSTEMS_TITLES[section]}</div>
                {isConfirmed && (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      handleConfigure(section);
                    }}
                    size='small'
                    startIcon={<AddCircle />}
                  >
                    Configure
                  </Button>
                )}
              </div>
              <div>
                {summaryList[section].map((item, index) => (
                  <div
                    key={index}
                    className='d-flex p-2 module-summary-item align-items-center justify-content-between'
                  >
                    <div className='d-flex w-50 '>
                      <div className='module-summary-item-name'>
                        {moduleList[section].find((m) => m.key === item.module).value}
                      </div>
                      <div className='d-flex module-summary-item-devices'>
                        <Tooltip title='PWA'>
                          <Language
                            color={item.enabledDevices.webApp ? 'primary' : 'secondary'}
                            onClick={() => handleDeviceClick(section, 'webApp', index)}
                            className='me-5'
                          />
                        </Tooltip>
                        <Tooltip title='Mobile app'>
                          <Smartphone
                            className='me-5'
                            color={item.enabledDevices.mobile ? 'primary' : 'secondary'}
                            onClick={() => handleDeviceClick(section, 'mobile', index)}
                          />
                        </Tooltip>
                        <Tooltip title='Tablet'>
                          <Tablet
                            className='me-5'
                            color={item.enabledDevices.tablet ? 'primary' : 'secondary'}
                            onClick={() => handleDeviceClick(section, 'tablet', index)}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className='d-flex align-items-center'>
                      {isConfirmed && (
                        <div className='d-flex align-items-center'>
                          Configuration status:
                          <Chip label='Pending' className='ms-2 pending' color='secondary' />
                        </div>
                      )}
                      <Button aria-controls='simple-menu' aria-haspopup='true'>
                        <MoreHoriz />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          {!isConfirmed && (
            <div>
              <div className='text-center gray-text my-4'>
                Click on confirm to activate all the selected modules
              </div>
              <div className='text-center mb-4'>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleConfirm}
                  size='large'
                  className='me-3'
                >
                  Confirm
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      {selectedValue && (
        <Modal open={selectedValue ? true : false} onClose={handleClose}>
          <div style={modalStyle} className={classes.paper}>
            <div className='enable-popup'>
              <div className='enable-popup-title'>
                Are you sure you want to {selectedValue.doEnable ? 'Enable' : 'Disable'}
                <br />
                {DEVICE_NAMES[selectedValue.device]} for {selectedValue.moduleName}?
              </div>
              <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
                <Button
                  variant='outlined'
                  size='large'
                  color='secondary'
                  onClick={(e) => handleClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant='contained'
                  size='large'
                  color='primary'
                  onClick={(e) => onStatusBtnClick()}
                >
                  {selectedValue.doEnable ? 'Enable' : 'Disable'}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ModuleSummary;
